<template>
  <div class="banners-page">
    <app-page-header title="Banners">
      <router-link
        :to="{ name: 'banners.create' }"
        tag="button"
        type="button"
        v-app-button.icon-left
      >
        <b-icon size="is-small" icon="plus"></b-icon>Novo
      </router-link>
    </app-page-header>

    <banners-table></banners-table>
  </div>
</template>

<script>
import BannersTable from '@/components/Tables/BannersTable.vue';

export default {
  name: 'banners-page',
  components: {
    BannersTable,
  },
};
</script>
